/* eslint-disable react/prop-types */
import React from 'react'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import MuiDialogContent from '@mui/material/DialogContent'
import ConfirmationDialog from '../Dialog/ConfirmationDialog'
import uploadManyDialogTranslations from './translations/uploadManyDialogTranslations'

const StyledDialogContent = styled(MuiDialogContent)(({ theme }) => ({
  maxWidth: 378,
  paddingBottom: theme.spacing(3),
  paddingRight: theme.spacing(3),
  backgroundColor: theme.palette.background.paper
}))

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1)
}))

const StyledDistance = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(1)
}))

interface IProps {
  includesZippedFiles: boolean
  selectedFilesCount: number
  open: boolean
  onCancel: () => void
  onOk: () => void
}

const DatasetUploadManyDialog = (props: IProps) => {
  const {
    includesZippedFiles,
    open,
    onCancel,
    onOk,
    selectedFilesCount
  } = props

  return (
    <ConfirmationDialog
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      cancel={uploadManyDialogTranslations.cancel}
      ok={uploadManyDialogTranslations.ok}
    >
      <StyledDialogContent>
        <StyledTitle variant="h3">
          {uploadManyDialogTranslations.titlePart1 +
            ' ' +
            selectedFilesCount +
            ' ' +
            uploadManyDialogTranslations.titlePart2}
        </StyledTitle>
        <Typography variant="body2">
          {uploadManyDialogTranslations.message}
        </Typography>
        {includesZippedFiles && (
          <StyledDistance variant="body2">
            {uploadManyDialogTranslations.additionalMessageForZippedFiles}
          </StyledDistance>
        )}
      </StyledDialogContent>
    </ConfirmationDialog>
  )
}

export default DatasetUploadManyDialog
